export type UnderwritingWarning = {
  code: string
  message: string
  severity: string
  blocking?: boolean
}

export const getUnderwritingWarnings = (
  priceResponse: unknown
): UnderwritingWarning[] =>
  (priceResponse as { warnings?: UnderwritingWarning[] })?.warnings ?? []

export const isCheckoutBlockedByWarnings = (
  warnings?: UnderwritingWarning[]
): boolean => !!warnings?.some((warning) => warning.blocking)
